import Spritz from "./src/Spritz";

window.Spritz = new Spritz(window.Spritz);
window.Spritz._flushQueue();

export default Spritz;
